import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';
import { LottoFacade } from '@fgb/core';

@Component({
  selector: 'fgb-lottos-page',
  templateUrl: './lottos-page.component.html',
})
export class LottosPageComponent implements OnInit, OnDestroy {
  constructor(private navigationService: NavigationService) {}

  private lottoFacade = inject(LottoFacade);

  ngOnInit() {
    this.navigationService.hideMobileNav();
    this.lottoFacade.fetchLottos();
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
